<!--
 * @Description: 页面主体内容组件，供程序框架使用
 * @Author: laoliu
 * @Date: 2021-01-17 22:43:52
 * @LastEditTime: 2022-11-01 15:40:28
-->
<template>
  <div class="body" ref="body">
    <app-breadcrumb v-bind:navInfo="navInfo" />
    <router-view @breadcrumb="handleBreadcrumb" @activeIndex="handleActiveIndex" />
    <el-backtop target=".el-main"></el-backtop>
  </div>
</template>

<script>
import Breadcrumb from './Breadcrumb'
export default {
  name: 'Content',
  data() {
    return {
      navInfo: {},
    };
  },

  components: {
    'app-breadcrumb': Breadcrumb
  },

  methods: {
    captureWindowSize() {
      this.$root.windowWidth = window.innerWidth;
      this.$root.windowHeight = window.innerHeight;
      if (this.$refs.body) {
        this.$root.contentWidth = this.$refs.body.clientWidth;
        this.$root.contentHeight = this.$refs.body.clientHeight;
      }
    },

    handleBreadcrumb(navInfo) {
      this.navInfo = navInfo;
    },

    handleActiveIndex(activeIndex) {
      this.$emit("activeIndex", activeIndex);
    },
  },

  /** 
   * @Description: 获取浏览器窗口高度及主体宽高，并设置onresize事件方法以实时获取上述数据
   * @Author: laoliu
   * @Date: 2021-02-11 09:43:09
   */
  mounted() {
    this.captureWindowSize();

    window.onresize = () => {
      return (() => {
        this.captureWindowSize();
      })()
    }
  }
}
</script>

<style scoped>
.body {
  text-align: center;
  border: solid green 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/pageframe/components/Content.vue